var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.dados.loading,
          expression: "dados.loading"
        }
      ],
      style: _vm.dados.loading ? "min-height: 100px;" : ""
    },
    [
      _vm.dados.spsList.length
        ? _c("Map", {
            attrs: {
              pratices: _vm.dados.spsList,
              propertyShapeImovel: _vm.dados.propertyShapeImovel,
              propertyShapePraticas: _vm.dados.propertyShapePraticas,
              onlyView: true
            }
          })
        : !_vm.dados.loading
        ? _c("div", [
            _c("span", [_vm._v("Não há georreferenciamento de práticas")])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6db41781", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6db41781","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Georreferenciamento/Georreferenciamento.vue
// module id = null
// module chunks = 